import React, { useRef } from 'react';
var VeltAutocompleteOptionIcon = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-option-icon", { ref: ref }, children));
};
export default VeltAutocompleteOptionIcon;
